package com.downdogapp.client.widget

import com.downdogapp.client.resources.Images
import com.downdogapp.client.resources.image
import org.w3c.dom.HTMLElement
import org.w3c.dom.HTMLImageElement

class Toggle(parent: HTMLElement,
             private val getValue: () -> Boolean,
             private val onValueChanged: (Boolean) -> Unit,
             sizePx: Int) {

  private var toggle: HTMLImageElement

  init {
    parent.apply {
      toggle = imageButton(
        width = sizePx,
        height = sizePx,
        clickFn = ::toggle
      )
    }
    refresh()
  }

  private fun toggle() {
    onValueChanged(!getValue())
    refresh()
  }

  fun refresh() {
    toggle.image = if (getValue()) Images.TOGGLE_ENABLED else Images.TOGGLE_DISABLED
  }
}

fun HTMLElement.toggle(getValue: () -> Boolean, onValueChanged: (Boolean) -> Unit, sizePx: Int = 50) =
  Toggle(this, getValue, onValueChanged, sizePx)
